// extracted by mini-css-extract-plugin
export default {"badge":"main_badge__NAq6z","notificationIcon":"main_notificationIcon__pPrso"};